import axios from 'axios';
import {getUrl} from '@/config/api.routes';

export default {
  namespaced: true,
  actions: {
    async export({ _ }, {id, unitType}) {
      const response = await axios.get(getUrl('aimanager.export', `${unitType}/${id}`));
      return response.data;
    },
    async import({ _ }, {payload, override}) {
      return await axios.post(getUrl('aimanager.import'), payload, { params: { override } });
    },
  },
};
